import React from 'react';

import './src/sass/_govflanders.scss';
import Layout from './src/components/Layout/Layout';
import { BrowserRouter as Router } from 'react-router-dom';
import { Location, globalHistory } from '@reach/router';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import '@govflanders/vl-ui-core';
import '@govflanders/vl-ui-tabs';
import '@govflanders/vl-ui-lightbox';
import '@govflanders/vl-ui-select';

import LightBox from '@govflanders/vl-ui-lightbox/src/js/lightbox';

import './src/sass/index.scss';
import favicon from './src/images/favicon.ico';
import { Helmet } from 'react-helmet';

export const wrapPageElement = ({ element }) => {
  return (
    <>
      <Helmet htmlAttributes={{ lang: 'nl' }} defer={false}>
        <link
          key="gatsby-plugin-plausible-preconnect"
          rel="preconnect"
          href="https://plausible.lblod.info"
        ></link>
        <script
          async
          defer
          data-domain="samenleven-in-diversiteit.vlaanderen.be"
          src="https://plausible.lblod.info/js/plausible.js"
        ></script>
        <link rel="icon" href={favicon} sizes="16x16" />
      </Helmet>
      <Router>
        <Location>
          {({ location }) => (
            <QueryParamProvider
              location={location}
              reachHistory={globalHistory}
              adapter={ReactRouter6Adapter}
            >
              <Layout>{element}</Layout>
            </QueryParamProvider>
          )}
        </Location>
      </Router>
    </>
  );
};

export const onRouteUpdate = () => {
  document.dispatchEvent(new Event('DOMContentLoaded'));
};

export const lb = new LightBox();
